import { IPlansState } from './state.interface';

export const PlanState: IPlansState = {
    allPlans: null,
    createPlanLoading: false,
    createPlanError: '',
    singlePlan: null,
    singlePlanLoading: true
};
